import Vue from 'vue';
import Vuex from 'vuex';

import { map } from "@/api";
Vue.use(Vuex);

import { isLocked, routes } from "../common/constants/routes";
import { user } from '@/pages/components/globalstore';
import servicesRelations from '@/common/constants/servicesRelations';

const addonsToPermissions = (addons) => {
  const permissions = [];

  if(addons.ALERTS) {
    permissions.push({id: servicesRelations.alerts});
  }
  if(addons.MANAGEMENT) {
    permissions.push({id: servicesRelations.management});
  }

  return permissions;
}

const state = {
  userData:  null,  // Lê os dados do localStorage
  userPermissions: {},
  ADD_ONS_ACCESS : {},
  routesPermissions: routes,
  positionInfos: {},
};

const mutations = {
  setUserData(state, payload) {
    state.userData = payload || {};
    localStorage.setItem('userData', JSON.stringify(payload)); // Salva os dados no localStorage quando eles são atualizados
  },
  setLocalUserData (state) {
    if (localStorage.getItem('userData')) {
      state.userData  = JSON.parse(localStorage.getItem('userData')) }
    else {
      state.userData = null;
    }
  },
  setAddonsAccess(state,payload) {
    state.ADD_ONS_ACCESS = payload || {};
    localStorage.setItem('ADD_ONS_ACCESS', JSON.stringify(payload));
  },
  setLocalAddonsAccess (state){
    const addons = localStorage.getItem('ADD_ONS_ACCESS');

    if (addons) {
      state.ADD_ONS_ACCESS  = JSON.parse(addons)}
    else {
      state.ADD_ONS_ACCESS = {}
    }
},
  setUserPermissions(state, payload) {
    state.userPermissions = payload || {}; 
  },
  setRoutesPermissions(state, payload) {
    state.routesPermissions = payload; 
  },
  setPositionInfos(state, payload) {
    state.positionInfos = payload; 
    
  }
  
};
const actions = {
  fetchUserPermissions({ state, commit }) {
    let services = [];
    if(state.userData && state.userData.ADD_ONS_ACCESS) {
      services = addonsToPermissions(state.userData.ADD_ONS_ACCESS);
    }
    
    const perms = {
      services,
      permissions: 
        Array.from(Array(20).keys()).map(i =>({id: i})),
      // [ { id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 9 }, { id: 16 }, ],
    };

    commit('setUserPermissions', perms);
  },
  async fetchPositionInfos({ commit }) {
    const position =  (await map.positionInfo());

    commit('setPositionInfos', position || {});
  },
  updateRoutesPermissions({ commit, state }) {
    const {
      permissions: userPermissions,
      services: userServices
    } = state.userPermissions;

    const routesBase = JSON.parse(JSON.stringify(routes));

    const routesWithPerms = routesBase.map(route => {
      const [isLockedRoute, lockedMessage] = isLocked({
        needPermissionId: route.needPermissionId,
        needServiceId: route.needServiceId,
        userPermissions,
        userServices,
      });

      route.isLocked = isLockedRoute;
      route.lockedMessage = lockedMessage;
  
      route.nestedRoutes.map(nestedRoute =>{
        const [isLockedRoute, lockedMessage] = isLocked({
          needPermissionId: nestedRoute.needPermissionId,
          needServiceId: nestedRoute.needServiceId,
          userPermissions,
          userServices,
        });

        nestedRoute.isLocked = isLockedRoute;
        nestedRoute.lockedMessage = lockedMessage;
    
        return nestedRoute;
      })
    
      return route;
    });

    commit('setRoutesPermissions', routesWithPerms);
  },
}

const getters = {
  authorized : state => !!state.userData,
  isAdmin : state =>{
    return state.userData.PERMISSION ===1 
  },
  routesWithPermissions: state => {
    return routes;
  }
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})